
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
 
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
import Credit from './Credit'
export default function CreditUser() {
    const { seriall } = useParams(); 
    const creditRef = useRef(null);
    useEffect(() => {

    }, []);



    return (
        <>
            <Credit  ref={creditRef} seriall={seriall} />
            <div className='container mt-3'>
                <div className='row'>
                    <div className='col'>
                        <button
                            className="  btn btn-success myCustomButton"
                            onClick={e => {
                                console.log('creditRef',creditRef)
                                if (creditRef.current && creditRef.current.addCredit)
                                    creditRef.current.addCredit(e);
                            }}>
                            <span>پرداخت</span>
                        </button>
                    </div>
                </div>
            </div>
        </>

    );

}
